/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React from 'react';
import ClassicEditor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import AppStyle from 'scss/main/App.module.scss';

const TextArea: React.FC<{
  value?: string;
  onReady?: (editor: any) => void;
  onError?: (error: Error, details: any) => void;
  onChange?: (event: any, editor: any) => void;
  onFocus?: (event: any, editor: any) => void;
  onBlur?: (event: any, editor: any) => void;
}> = ({
  value, onReady, onError, onChange, onFocus, onBlur
}) => {

  return (
    <div className={AppStyle['textarea']}>
      <CKEditor
        editor={ClassicEditor as any}
        data={value}
        onReady={onReady}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onError={onError}
      />
    </div>
  );
}

export default TextArea;